import moment from 'moment';
import React, { Component, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import './customReactDatepicker.css';
import './reports.css';
import ReportIcon from './../../../assets/img/mm/icon-4.png';
class AccountBalSummaryReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: props.reportDefaultDate || new Date(),
            accountBalSummaryReport: [],
            userInfo: getLoginDistrictInfo(),
        }
    }
    componentWillMount = () => {
        this.getAccountBalSummaryReport();
    }
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.selectSchool != this.props.selectSchool) {
            this.getAccountBalSummaryReport();
        }
    }
    getSystemDateTime = (date) => {
        let _datetime = moment(date, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")
        return _datetime;
    }
    getAccountBalSummaryReport = () => {
        const schoolID = parseInt(this.props.selectSchool);
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear
        const districtID = this.state.userInfo.districtId
        const s_d_id = schoolID > 0 ? schoolID : districtID
        const isDistId = schoolID > 0 ? false : true;
        let start = this.getSystemDateTime(moment(this.state.startDate));
        const _url = `/reports/accBalanceSummary/${s_d_id}?isDistrict=${isDistId}&schoolYear=${schoolYear}&isExport=false&dateV=${start}&access_token=`;
        get(_url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const resData = (data.response || [])
            this.setState({ accountBalSummaryReport: resData, loading: false })
        }).catch(error => {
            this.setState({ accountBalSummaryReport: [], loading: false })
            console.log("Loading Report Failed", error)
        })
    }
    bindData = () => {
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
        const sd_id = schoolID > 0 ? schoolID : districtID
        const isDistrict = schoolID > 0 ? false : true;
        let start1 = this.getSystemDateTime(moment(this.state.startDate));
        const _url = `/reports/accBalanceSummary/${sd_id}?isDistrict=${isDistrict}&schoolYear=${schoolYear}&isExport=true&dateV=${start1}&access_token=`;

        this.setState({ loading: true })
        get(_url).then((response) => {
            if (!response.ok) {
                if (response.status === 417 || response.status === 422) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                _addNotificationError(res.statusMessage, this.props)
                throw Error(res.errorMessage);
            } else if (res.statusCode === 422) {
                throw Error(res.statusMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = "RevenueReport";
            showFile(blob, filename);
            this.setState({ loading: false })
        }).catch((error) => {
            let msg = ''
            if (typeof error === 'string') {
                msg = error;
            } else {
                msg = error.message;
            }
            _addNotificationError(msg, this.props);
            this.setState({ loading: false })
        }
        );
    }
    buildAccountBalSummaryDataFormatForExport = () => {
        return (
            [{
                columns: [{ title: 'SCHOOL' }, { title: 'STAFF A/C BALANCE' }, { title: 'STAFF NEGATIVE BALANCE' }, { title: 'STUDENT A/C BALANCE' },
                { title: 'STUDENT NEGATIVE BALANCE' }],
                data: this.state.accountBalSummaryReport.map(item => {
                    return [{ value: item.schoolName || 0 },
                    { value: item.staffAccBalance || 0 },
                    { value: item.staffNegativeBalance || 0 },
                    { value: item.stdAccBalance || 0 },
                    { value: item.stdNegativeBalance || 0 }
                    ]
                })
            }]
        );
    }
    render() {
        const { startDate } = this.state;
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={ReportIcon} />
                                </div>
                                <div className="reportCard-widget-meeting-info" >
                                    <span className="reportCard-widget-pro-title color-3"><b>Account Balance Summary Report</b></span>
                                </div>
                            </div>
                            <div className="reportCard-widget-meeting-points">
                                <div className="row form-group">
                                    <label class="col-sm-12 control-label">Date</label>
                                    <div className="col-sm-12 ">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={startDate}
                                            onChange={(date) => {
                                                this.setState({ startDate: date });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>
                            </div>
                            <div className='reportCard-widget-meeting-action'>
                                <div className="form-group">
                                    <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px 5px 0px 0px' }} onClick={() => {
                                        this.bindData()
                                    }}>
                                        Download Report
                                    </button>
                                    <TmExportExcel
                                        id={"accountBalSummaryReport"}
                                        name={"AccountBalanceSummaryReport"}
                                        filename={"Account Balance Summary Report"}
                                        element={<button type='button' id={"accountBalSummaryReport"} className="btn btn-warning btn-sm" style={{ margin: '0px 5px 0px 0px' }}><i className="fa fa-file-excel-o"></i> Export</button>}
                                        dataSet={this.buildAccountBalSummaryDataFormatForExport()}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default AccountBalSummaryReport;


// WEBPACK FOOTER //
// ./src/components/District/Reports/accountBalSummaryReport.js